var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.694 3.30605C9.61922 2.23132 7.87674 2.23132 6.80201 3.30605L6.79852 3.30954L5.82636 4.26897L4.7727 3.20136L5.74317 2.24357C7.40383 0.584871 10.0947 0.585478 11.7546 2.24539C13.4145 3.90528 13.4151 6.59611 11.7565 8.25678L10.7986 9.2273L9.73103 8.17364L10.6905 7.20149L10.694 7.19799C11.7687 6.12326 11.7687 4.38078 10.694 3.30605ZM9.22733 5.83333L5.83333 9.22733L4.77267 8.16667L8.16667 4.77267L9.22733 5.83333ZM4.26897 5.82636L3.30606 6.80202C2.23133 7.87675 2.23132 9.61922 3.30605 10.694C4.38078 11.7687 6.12326 11.7687 7.19799 10.694L7.20148 10.6905L8.17364 9.73103L9.2273 10.7986L8.25686 11.7564C6.5962 13.4151 3.90531 13.4145 2.24539 11.7546C0.585479 10.0947 0.58487 7.40384 2.24356 5.74317L3.20136 4.7727L4.26897 5.82636Z",
    fill: "#2B2F33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.9680bc41dc94d0663088cd418bf29a8a.svg";
export { ForwardRef as ReactComponent };